import React from 'react';
import { Link } from 'react-router-dom';

function BlogPost(props) {
    const {
        blogSlug,
        blogImage,
        blogTitle,
        blogExcerpt,
        blogAuthor,
        blogDate,
        blogCategory,
        blogReadTime
    } = props;

    return (
        <div className="th-blog blog-single has-post-thumbnail">
            <div className="blog-img">
                <Link to={`/blog/${blogSlug}`}>
                    <img src={`/assets/img/blog/${blogImage}`} alt={blogTitle} />
                </Link>
            </div>
            <div className="blog-content">
                <div className="blog-meta">
                    <Link className="author" to="/blog">
                        <i className="fa-light fa-user" />
                        by {blogAuthor}
                    </Link>
                    <Link to="/blog">
                        <i className="fa-solid fa-calendar-days" />
                        {blogDate}
                    </Link>
                    <Link to={`/blog/${blogSlug}`}>
                        <img src="/assets/img/icon/map.svg" alt="" />
                        {blogCategory}
                    </Link>
                    <Link to={`/blog/${blogSlug}`}>
                        <i className="fa-light fa-clock" />
                        {blogReadTime}
                    </Link>
                </div>
                <h2 className="blog-title">
                    <Link to={`/blog/${blogSlug}`}>{blogTitle}</Link>
                </h2>
                <p className="blog-text">{blogExcerpt}</p>
            </div>
        </div>
    );
}

export default BlogPost;
